import React from 'react';
import columns from './columns';
import messages from '../messages';
import Breadcrumbs from 'components/Common/Breadcrumb';
import Table from 'features/table';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import {Container} from 'reactstrap';

const TrashedUsersPage = () => {
  const {t} = useTranslation();

  return (
    <div className="page-content pb-0">
      <Helmet>
        <title>{t(...messages.trash())}</title>
      </Helmet>
      <Container fluid>
        <Breadcrumbs
          breadcrumbItems={[
            {title: t(...messages.dashboard()), path: '/dashboard'},
            {title: t(...messages.users()), path: '/dashboard/users'},
            {title: t(...messages.trashedUsers()), path: '#'},
          ]}
        />
        <Table url="trashed/users" name="trashed-users" columns={columns} />
      </Container>
    </div>
  );
};

export default TrashedUsersPage;